import { connectScheduleMenu, type ScheduleMenuAnalyticProps } from 'components/shared/ScheduledRun/ScheduleMenu';
import type { IdOwnProps } from 'components/shared/ScheduledRun/type';
import { isScheduledRunOnStaticOrDynamicEnabled } from 'state/scheduledRuns/utils';
import { getQuoteInfoByWorkspaceTab } from 'state/selectors/common/temp';
import type { QuoteWorkspaceType } from 'state/workspaces/model';

interface OwnProps extends IdOwnProps, ScheduleMenuAnalyticProps {
  workspaceType: Extract<QuoteWorkspaceType, 'static' | 'dynamic'>;
}
export const ConnectedScheduleMenu = connectScheduleMenu<OwnProps>((state, { id, workspaceType }) => {
  const quote = getQuoteInfoByWorkspaceTab(state, workspaceType, id);
  const isVisible = isScheduledRunOnStaticOrDynamicEnabled(workspaceType, state);
  return { quotes: quote ? [quote] : [], isVisible: isVisible };
});
